//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data:function(){
        return {
            status: "error"
        }
    },
    methods: {
        changeStatus: function() {
            switch (this.status) {
                case "":
                    this.status = "process";
                    break;
                case "process":
                    this.status = "finish";
                    break;
                case "finish":
                    this.status = "error";
                    break;
                case "error":
                    this.status = "";
                    break;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./example/pages/steps.vue